import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../ui/Button";
import { clearTokens } from "../../services/storage/token.storage";

const Header: React.FC = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        clearTokens();
        navigate("/login");
    };

    return (
        <header className="app-header">
            <div>
                <p className="app-header-eyebrow">ShowMust Admin</p>
                <h2 className="app-header-title">Панель управления</h2>
            </div>

            <div className="app-header-actions">
                <div className="user-chip">
                    <span className="user-chip-avatar">A</span>
                    <span className="user-chip-text">Администратор</span>
                </div>

                <Button variant="secondary" onClick={handleLogout}>
                    Выйти
                </Button>
            </div>
        </header>
    );
};

export default Header;
